import React, { useState, useCallback, useMemo, useContext } from 'react';
import { SORT_BY_STRING } from '@ubeya/shared/utils/sorting';
import styled from 'styled-components';
import DropDown from '../../DropDown';
import CheckBox from '../../CheckBox';
import FilterLayout from '../FilterLayout';
import ConfigContext from '../../../contexts/ConfigContext';
import { TextWithTooltip } from '../../Tooltip';

const ProjectLiveViewLocationsFilterText = styled(TextWithTooltip)`
  max-width: 200px;
`;

const ProjectLiveViewLocationsFilter = ({
  slug,
  defaultValue,
  handleClose,
  onApply,
  search,
  onChange,
  externalOptions = {},
  hideLayout = false
}) => {
  const { t } = useContext(ConfigContext);
  const locationsOptions = (externalOptions[slug] || [])
    .map(({ id, value }) => ({
      value: id,
      label: value
    }))
    .sort(SORT_BY_STRING('label'));

  const [values, setValues] = useState(defaultValue || []);

  const handleChange = useCallback(
    (value) => {
      const newValues = values.includes(value) ? values.filter((item) => item !== value) : [...values, value];
      setValues(newValues);
      onChange?.(newValues);
    },
    [onChange, values]
  );

  const filteredOptions = useMemo(
    () =>
      search
        ? (locationsOptions || []).filter(
            ({ label }) =>
              t('locations').toLowerCase().includes(search.toLowerCase()) ||
              label.toLowerCase().includes(search.toLowerCase())
          )
        : locationsOptions,
    [locationsOptions, search, t]
  );

  if (!filteredOptions.length) {
    return null;
  }

  return (
    <FilterLayout
      name={t('locations')}
      handleClose={handleClose}
      onApply={() => onApply(values)}
      hideLayout={hideLayout}>
      {filteredOptions.map(({ value, label }) => (
        <DropDown.Item key={value}>
          <CheckBox name={`location-${value}`} value={values.includes(value)} onChange={() => handleChange(value)}>
            <ProjectLiveViewLocationsFilterText>{label}</ProjectLiveViewLocationsFilterText>
          </CheckBox>
        </DropDown.Item>
      ))}
    </FilterLayout>
  );
};

export default ProjectLiveViewLocationsFilter;
